import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Generated class for the RmtWarningCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-warning-card',
  templateUrl: 'rmt-warning-card.html'
})
export class RmtWarningCardComponent {

  @Input() title: string;
  @Input() buttonTitle: string;
  @Input() hyperLink: string;
  @Input() messageType: MessageType = MessageType.Error;
  @Output() buttonAction = new EventEmitter();

  constructor() {
  }

  onClick() {
    this.buttonAction.emit();
  }

}

export enum MessageType {
  Error = "Error",
  Warning = 'Warning'
}



// WEBPACK FOOTER //
// ./src/components/rmt-warning-card/rmt-warning-card.ts